import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { selectors } from '../../reducer';
import * as actions from '../../actions';
import * as Styled from './RxGateAvailableReceiptsBlock.styles';

const RxGateAvailableReceiptsBlock: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const rxGateCurrentReceipt = useSelector(selectors.rxGateCurrentReceipt);

  if (!rxGateCurrentReceipt) return null;

  return (
    <Styled.AllReceiptsBlock>
      {rxGateCurrentReceipt.length > 0 ? (
        <>
          {rxGateCurrentReceipt.map((item) => (
            <div
              className="receipt-item"
              key={item.docId}
              onClick={() => {
                dispatch(actions.setRxGateChosenReceipt.request(item));
              }}
            >
              <h2 className="receipt-item-title">
                {t('LoyaltyPage.ACTIVE_RECEIPT')} №{item.docId}
              </h2>
              {item.products?.map((item, index) => (
                <div className="receipt-item-product" key={item.sku}>
                  {index + 1}. {item.name} x {item.quantity} шт.
                </div>
              ))}
            </div>
          ))}
        </>
      ) : (
        <p className="not-available-receipts">
          {t('LoyaltyPage.NOT_AVAILABLE_RECEIPTS')}
        </p>
      )}
    </Styled.AllReceiptsBlock>
  );
};

export default RxGateAvailableReceiptsBlock;
